
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';

import validateEmail from '../../common/validateEmail';
import DialogAlert from './DialogAlert';
import useAuth from '../hooks/useAuth';
import { getActions as authGetActions } from '../sagas/auth';

const classNames = mergeStyleSets({
    CreateAccountForm: {
        backgroundColor: '#ffffff',
        width: '400px',
        padding: '16px'
    },
    agreement: {
        paddingTop: 8,
        paddingBottom: 8
    }
});

const CreateAccountForm = ({styles, onCancelClick}) => {

    const dispatch = useDispatch();
    const authActions = authGetActions(dispatch);

    const auth = useAuth();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [email, setEmail] = useState('');
    const [fullName, setFullName] = useState('');
    const [agreement, setAgreement] = useState(false);

    const checkParams = () => {
        let errors = [];
        if (!username) {
            errors.push('Uživatelské jméno musí být zadané');
        }
        if (username) {
            const regex = new RegExp(/^[a-zA-Z0-9_\-.]*$/g);
            if (!regex.test(username)) {
                errors.push('Uživatelské jméno může obsahovat pouze následující znaky: <b>a-z</b>, <b>A-Z</b>, <b>0-9</b>, <b>-</b>, <b>_</b>, <b>.</b>');
            }
        }
        if (!(password && password2 && (password === password2))) {
            errors.push('Heslo a jeho potvrzení musí být zadané a musí se shodovat');
        }
        if (!fullName) {
            errors.push('Jméno a příjmení musí být zadané');
        }
        if (!email) {
            errors.push('E-mailová adresa musí být zadaný');
        }
        if (!validateEmail(email)) {
            errors.push('E-mailová adresa není platná');
        }
        if (!agreement) {
            errors.push('Musíte souhlasit se smluvními podmínkami provozu serveru')
        }

        return errors;
    }

    const handleCancelClick = () => {
        if (onCancelClick) {
            onCancelClick();
        }
    }

    const handleCreateClick = async (event) => {
        let errors = checkParams();
        if (errors.length === 0) {
            authActions.createAccount(username, password, fullName, email);
        } else {
            await DialogAlert.show(errors.reduce(
                (previous, current) => {
                    return previous + `- ${current}<br/>`;
                }, 'Nejsou splněny následující podmínky a proto nelze ve vytvoření uživatelského účtu pokračovat:<br/></br/>'),
                {minWidth: 600});
        }
    }

    const handleChangeEmail = (event) => {
        setEmail(event.target.value);
    }

    const handleChangeFullName = (event) => {
        setFullName(event.target.value);
    }

    const handleChangePassword = (event) => {
        setPassword(event.target.value);
    }

    const handleChangePassword2 = (event) => {
        setPassword2(event.target.value);
    }

    const handleChangeUserName = (event) => {
        setUsername(event.target.value);
    }

    const handleChangeAgreement = (event, checked) => {
        setAgreement(checked);
    }

    const handleAgreementRenderLabel = () => {
        return (
            <span>
                Souhlasím se{' '}
                <Link href="/portal/files/smluvni_podminky.pdf" target="_blank" underline>
                    smluvními podmínkami
                </Link>
                {' '}provozu serveru
            </span>
        );
    }

    const getClassName = (name) => {
        return styles
            ? styles[name]
            : classNames[name];
    }

    return (
        <Stack className={getClassName('CreateAccountForm')} tokens={{childrenGap: 16}}>
            <Stack.Item>
                <TextField
                    label="Uživatelské jméno"
                    disabled={auth.loading}
                    onChange={handleChangeUserName}
                />
                <TextField
                    label="Heslo"
                    type="password"
                    canRevealPassword={true}
                    disabled={auth.loading}
                    onChange={handleChangePassword}
                />
                <TextField
                    label="Potvrzení hesla"
                    type="password"
                    canRevealPassword={true}
                    disabled={auth.loading}
                    onChange={handleChangePassword2}
                />
                <TextField
                    label="E-mailová adresa"
                    disabled={auth.loading}
                    onChange={handleChangeEmail}
                />
                <TextField
                    label="Jméno a příjmení"
                    disabled={auth.loading}
                    onChange={handleChangeFullName}
                />
                <div className={classNames.agreement}>
                    <Checkbox
                        disabled={auth.loading}
                        onChange={handleChangeAgreement}
                        onRenderLabel={handleAgreementRenderLabel}
                    />
                </div>
                <div>Na zadanou e-mailovou adresu Vám bude zaslán aktivační kód. Bez tohoto kódu nebude možné dokončit aktivaci uživatelského účtu.</div>
            </Stack.Item>
            <Stack.Item>
                <Stack horizontal tokens={{childrenGap: 8}}>
                    <PrimaryButton
                        text="Vytvořit účet"
                        disabled={auth.loading}
                        onClick={handleCreateClick}
                    />
                    <DefaultButton
                        text="Zpět"
                        onClick={handleCancelClick}
                    />
                </Stack>
            </Stack.Item>
        </Stack>
    );
}

export default CreateAccountForm;
